export const onLogin = () => {
	const {
		origin,
		hash
	} = window.location
	const url = origin + '/learning/' + hash;
	let urlEco = encodeURIComponent(url)
	window.location.href = `https://unified.cacpaper.com/login?callback=${urlEco}`;
};

export function getUrlSearch() {
	return location.search
		.replace(/(^\?)|(&$)/g, "")
		.split("&")
		.reduce((t, v) => {
			const [key, val] = v.split("=");
			t[key] = decodeURIComponent(val);
			return t;
		}, {});
}
